"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var store_provider_1 = require("./store-provider");
var BlockRendering = /** @class */ (function (_super) {
    __extends(BlockRendering, _super);
    function BlockRendering() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockRendering.prototype.render = function () {
        var _a = this.props, renderComponent = _a.renderComponent, allProps = __rest(_a, ["renderComponent"]);
        return renderComponent(allProps);
    };
    return BlockRendering;
}(React.PureComponent));
exports.withStore = function (mapStateToProps) { return function (WrappedComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(ComponentWithStore, _super);
            function ComponentWithStore() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ComponentWithStore.prototype.render = function () {
                var _this = this;
                var renderComponent = function (props) { return (React.createElement(WrappedComponent, __assign({}, props))); };
                return (React.createElement(store_provider_1.Consumer, null, function (injectedStore) {
                    var injectedProps = mapStateToProps(injectedStore);
                    return (React.createElement(BlockRendering, __assign({ renderComponent: renderComponent }, _this.props, injectedProps)));
                }));
            };
            return ComponentWithStore;
        }(React.Component)),
        _a.displayName = "Connect(" + (WrappedComponent.displayName ||
            WrappedComponent.name ||
            'Unknown') + ")",
        _a;
}; };
//# sourceMappingURL=with-store.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/state-manager/with-store.js
// module id = 1191
// module chunks = 8